export interface AuthenticatedUser {
  email: string;
  name: string;
  token: UserTokens;
  role: WorkspaceUserRole;
  workspaceId: string;
}

export interface UserTokens {
  accessToken: string;
  refreshToken: string;
}

export interface ValidateUser {
  password: string;
  email: string;
}

export enum WorkspaceUserState {
  PasswordNotSet = "password_not_set",
  PasswordSet = "password_set",
}

export enum WorkspaceUserRole {
  User = "user",
  Admin = "admin",
  SuperAdmin = "super_admin",
}

export interface ISignInWithUserPasswordPayload {
  email: string;
  password: string;
}

export interface SetPasswordPayload {
  code: string;
  password: string;
}
